exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (min-width: 992px){.e66771{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:100vh}}._4d7f0d{min-width:50%}", ""]);
// Exports
exports.locals = {
	"flex": "e66771",
	"column": "_4d7f0d"
};